import { render, staticRenderFns } from "./RuleAdapter.vue?vue&type=template&id=16c71e16&scoped=true&"
import script from "./RuleAdapter.vue?vue&type=script&lang=js&"
export * from "./RuleAdapter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c71e16",
  null
  
)

export default component.exports